import { ExternalLink } from "lucide-react";

export function PageHero({ eyebrow, title, subtitle, children, image, imageAlt, imageClass = "max-h-[420px] object-cover" }) {
  return (
    <header className="relative bg-[#0B2A4A] text-[#F5ECD7] grain overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16 sm:py-24 grid lg:grid-cols-[1.4fr_1fr] gap-10 items-center">
        <div>
          <p className="rise font-mono-ui text-xs tracking-[0.3em] text-[#F08A3C]">{eyebrow}</p>
          <h1 className="rise rise-1 mt-5 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] text-white">{title}</h1>
          <h2 className="rise rise-2 mt-6 text-base md:text-lg font-normal text-[#F5ECD7]/85 max-w-2xl leading-relaxed">{subtitle}</h2>
          {children && <div className="rise rise-3 mt-8 flex flex-wrap gap-3">{children}</div>}
        </div>
        {image && <img src={image} alt={imageAlt} className={`rise rise-2 w-full rounded-3xl shadow-2xl ${imageClass}`} />}
      </div>
    </header>
  );
}

export function OutLink({ href, children, testId, light = false }) {
  return (
    <a href={href} target="_blank" rel="noopener" className={`inline-flex items-center gap-2 rounded-xl px-5 py-3 font-semibold transition-colors ${light ? "bg-white/10 text-white border border-white/25 hover:bg-white/20" : "bg-[#1A9AA8] text-white hover:bg-[#147C88]"}`} data-testid={testId}>
      {children} <ExternalLink className="h-4 w-4" />
    </a>
  );
}

export function StatGrid({ stats }) {
  return (
    <dl className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map(([v, l]) => (
        <div key={l} className="bg-white rounded-2xl border border-[#0B2A4A]/10 p-5">
          <dt className="font-display text-2xl sm:text-3xl font-bold text-[#0B2A4A]">{v}</dt>
          <dd className="mt-1 text-sm text-slate-600">{l}</dd>
        </div>
      ))}
    </dl>
  );
}
